<template>
  <div class="cai-list-container">
    <el-table
      v-loading="loading"
      :data="caigoulistList"
      @row-click="goInfo"
      class="custom-table"
      stripe
    >
      <el-table-column label="公告标题" min-width="400">
        <template slot-scope="scope">
          <div class="title-cell">
            <span class="title-text">{{ scope.row.title }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="发布单位"
        width="220"
        prop="author"
        show-overflow-tooltip
      />
      <el-table-column
        label="项目类型"
        width="150"
        prop="gpCatalogName"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag size="small" effect="plain">{{
            scope.row.gpCatalogName || "暂无"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="发布日期" align="center" width="150">
        <template slot-scope="scope">
          <span class="date-text">{{
            scope.row.publishDate.slice(0, 10)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template>
          <el-button type="text" size="small" class="view-btn"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import article from "@/api/article";
export default {
  name: "CaiList",
  props: {
    searchString: {
      type: String,
      default: "",
    },
  },
  watch: {
    searchString: {
      handler(newData) {
        this.pagination.current = 1;
        this.getList(newData);
      },
      immediate: true,
    },
  },
  data() {
    return {
      loading: true,
      caigoulistList: [],
      pagination: {
        total: 0,
        size: 10,
        current: 1,
      },
    };
  },
  methods: {
    getList(titleText) {
      this.loading = true;
      let params = {
        size: this.pagination.size,
        current: this.pagination.current,
        title: titleText || this.searchString,
        categoryNames: "采购公告",
      };
      article
        .getList(params)
        .then((res) => {
          let result = res.data.data;
          this.pagination.total = result.total;
          this.pagination.size = result.size;
          this.pagination.current = result.current;
          this.caigoulistList = result.records;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.pagination.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
    goInfo(row) {
      this.$router.push({
        path: "/listinfo",
        query: { articleId: row.articleId },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";

.cai-list-container {
  width: 100%;
}

.custom-table {
  /deep/ .el-table__header-wrapper th {
    background-color: #f8fafc;
    color: @text-main;
    font-weight: 600;
    height: 54px;
  }

  /deep/ .el-table__row {
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: @primary-light !important;
    }
  }
}

.title-cell {
  padding: 4px 0;
  .title-text {
    font-size: 15px;
    color: @text-main;
    transition: color 0.3s;

    &:hover {
      color: @primary-color;
    }
  }
}

.date-text {
  color: @text-muted;
  font-size: 14px;
}

.view-btn {
  font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
}

.pagination-container {
  margin-top: 32px;
  display: flex;
  justify-content: center;
}
</style>
